import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const JourneyImageSection = () => {
  return <section className="py-20 bg-[#050505] relative overflow-hidden" data-id="element-2831">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30 pointer-events-none" data-id="element-2832" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-2833">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-2834">
          {/* Forensic Frame */}
          <div className="relative p-2 border border-[#FFD700]/30 bg-[#0a0a0a]" data-id="element-2835">
            {/* Corner Markers */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#FFD700] z-20" data-id="element-2836" />
            <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#FFD700] z-20" data-id="element-2837" />
            <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#FFD700] z-20" data-id="element-2838" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#FFD700] z-20" data-id="element-2839" />

            <div className="relative overflow-hidden rounded-lg" data-id="element-2840">
              <img src="https://cdn.magicpatterns.com/uploads/kPGzyJsWeZg8UDY4FqnWQn/file_000000003e9471f4b06dd33cf953f6ef.png" alt="Silhouette walking through digital landscape of toxic messages on red glowing grid - representing the journey through relationship analysis and finding clarity" className="w-full h-auto object-cover" loading="lazy" decoding="async" data-id="element-2841" />

              {/* Progress Indicator */}
              <div className="absolute bottom-4 left-4 right-4 bg-black/70 border border-[#FFD700]/50 px-4 py-2" data-id="element-2842">
                <div className="flex items-center justify-between mb-1" data-id="element-2843">
                  <span className="text-[#FFD700] text-xs font-mono tracking-wider uppercase" data-id="element-2844">
                    Analysis Progress
                  </span>
                  <span className="text-[#FFD700] text-xs font-mono" data-id="element-2845">100%</span>
                </div>
                <div className="w-full h-1 bg-gray-800 rounded-full overflow-hidden" data-id="element-2846">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 2,
                  ease: 'easeOut'
                }} className="h-full bg-gradient-to-r from-[#FF0000] to-[#FFD700]" data-id="element-2847" />
                </div>
              </div>
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-[#FFD700]/5 blur-3xl -z-10 rounded-full" data-id="element-2848" />
        </motion.div>
      </div>
    </section>;
};